<template>
  <v-card class="text-xs-center">
    <storeOptionList />
  </v-card>
</template>

<script>
import storeOptionList from "@/components/back-office/InStore/ProductManagement/Option/StoreOptionListTable.vue";

export default {
  components: {
    storeOptionList,
  },
  destroyed() {
    if (this.$route.name != "storeproductform") {
      this.$store.commit("fetchProductTypeBack/resetState");
      this.$store.commit("fetchProductListBack/resetState");
    }
  },
  async created() {},
  mounted() {
    const path = [
      {
        text: "Select province",
        disabled: false,
        href: "/weserve_admin_login/select/",
      },
      {
        text: "Select service",
        disabled: false,
        href: "/weserve_admin_login/control/" + this.$route.params.province,
      },
      {
        text: "Store&Product",
        disabled: false,
        href:
          "/weserve_admin_login/control/" +
          this.$route.params.province +
          "/storeandproduct/storemanage",
      },
      {
        text: "Product list",
        disabled: true,
      },
    ];
    this.$store.commit("backOffice/saveRecentRoute", path);
  },
};
</script>

<style>
</style>
